import { SushiLunchProducts } from "../modules/sushiLunchProducts";

export const SushiLunchProductsPage = () => {
  return <SushiLunchProducts />;
};
